var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "flex-column" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.states,
                  dense: "",
                  "hide-details": "",
                  label: "Состояние",
                },
                model: {
                  value: _vm.value.state,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "state", $$v)
                  },
                  expression: "value.state",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  max: _vm.reservoir.grids_x * _vm.reservoir.dx,
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "X",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("м")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.x_coord,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "x_coord", _vm._n($$v))
                  },
                  expression: "value.x_coord",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  max: _vm.reservoir.grids_y * _vm.reservoir.dy,
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "Y",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("м")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.y_coord,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "y_coord", _vm._n($$v))
                  },
                  expression: "value.y_coord",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  max: _vm.reservoir.grids_z * _vm.reservoir.dz,
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "Z (относительная)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("м")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.z_coord_relative,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "z_coord_relative", _vm._n($$v))
                  },
                  expression: "value.z_coord_relative",
                },
              }),
              _vm._v(" " + _vm._s(_vm.value ? _vm.value.z_coord : "") + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  dense: "",
                  hint: "Толщина нефтеносного слоя",
                  "persistent-hint": "",
                  type: "number",
                  label: "h",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("м")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.h_net_thickness,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "h_net_thickness", _vm._n($$v))
                  },
                  expression: "value.h_net_thickness",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  dense: "",
                  hint: "Длина перфорации",
                  "persistent-hint": "",
                  type: "number",
                  label: "l",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("м")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.l_perforation_length,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "l_perforation_length", _vm._n($$v))
                  },
                  expression: "value.l_perforation_length",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  max: "1",
                  step: "0.1",
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "p",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_vm._v("S"), _c("sub", [_vm._v("w")])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.sw_water_saturation,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "sw_water_saturation", _vm._n($$v))
                  },
                  expression: "value.sw_water_saturation",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "k",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("мД")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.k_permeability,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "k_permeability", _vm._n($$v))
                  },
                  expression: "value.k_permeability",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  dense: "",
                  "hide-details": "",
                  type: "number",
                  label: "p",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [_vm._v("бар")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.p_pressure,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "p_pressure", _vm._n($$v))
                  },
                  expression: "value.p_pressure",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  min: "0",
                  dense: "",
                  "hide-details": "",
                  type: "number",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_vm._v("φ")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.value.phi_porosity,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "phi_porosity", _vm._n($$v))
                  },
                  expression: "value.phi_porosity",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }